/* Sniggles product-card behaviors. Vanilla JS, no framework, no Liquid.
   Event-delegated at the document level so it also covers cards appended by
   the PLP "show more" and by rails re-rendering in the theme editor.

   - Variant-photo swatches: tapping a swatch swaps the card's main image.
   - Quick view: an eye trigger ([data-sn-quickview]) opens a modal that fetches
     a compact buy-box (sections/sniggles-quick-view.liquid) via the Section
     Rendering API and wires it here (variant pills -> price/image/availability,
     AJAX add-to-bag honoring the cart drawer contract). Self-contained: does not
     depend on sniggles-pdp.js being present on the page. */
(function () {
  'use strict';

  // ---------------------------------------------------------------- Swatches
  function onSwatchClick(sw) {
    var card = sw.closest('.sn-product-card');
    if (!card) return;
    var full = sw.getAttribute('data-full');
    var img = card.querySelector('.sn-product-card__media img');
    if (img && full) {
      img.setAttribute('src', full);
      img.removeAttribute('srcset');
    }
    var row = sw.closest('[data-sn-swatches]');
    if (row) {
      var all = row.querySelectorAll('[data-sn-swatch]');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.toggle('is-active', all[i] === sw);
      }
    }
  }

  // -------------------------------------------------------------- Quick view
  var overlay = null, dialog = null, body = null, lastFocus = null, isOpen = false;

  function buildShell() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'sn sn-qv-overlay';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="sn-qv-scrim" data-sn-qv-close></div>' +
      '<div class="sn-qv-dialog" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button class="sn-qv-close" type="button" data-sn-qv-close aria-label="Close quick view">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="sn-qv-body" data-sn-qv-body></div>' +
      '</div>';
    document.body.appendChild(overlay);
    dialog = overlay.querySelector('.sn-qv-dialog');
    body = overlay.querySelector('[data-sn-qv-body]');
    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-sn-qv-close]')) closeQV();
    });
  }

  function money(currency, cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: currency
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function wireBuybox(root) {
    if (!root) return;
    var currency = root.getAttribute('data-currency') || 'USD';
    var addLabel = root.getAttribute('data-add-label') || 'Add to bag';
    var soldLabel = root.getAttribute('data-soldout-label') || 'Sold out';
    var errLabel = root.getAttribute('data-error-label') || 'Something went wrong. Please try again.';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-qv-variants]').textContent); } catch (e) { variants = []; }

    var form = root.querySelector('[data-qv-form]');
    var vidInput = root.querySelector('[data-qv-variant-id]');
    var priceBox = root.querySelector('[data-qv-price]');
    var addBtn = root.querySelector('[data-qv-add]');
    var addBtnLabel = root.querySelector('[data-qv-atb-label]');
    var errorBox = root.querySelector('[data-qv-error]');
    var image = root.querySelector('[data-qv-image]');

    function priceHTML(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var h = '<span class="sn-price' + (sale ? ' sn-price--sale' : '') + '">';
      h += '<span class="sn-price__current">' + money(currency, v.price) + '</span>';
      if (sale) h += '<span class="sn-price__was">' + money(currency, v.compare_at_price) + '</span>';
      return h + '</span>';
    }

    function selectedValues() {
      return Array.prototype.map.call(root.querySelectorAll('[data-qv-opt]'), function (opt) {
        var a = opt.querySelector('[data-qv-pill].is-active');
        return a ? a.getAttribute('data-option-value') : null;
      });
    }

    function matchVariant(vals) {
      if (!variants.length) return null;
      if (!vals.length || vals[0] === null) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (variants[i].options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function current() { return matchVariant(selectedValues()) || variants[0] || null; }

    function apply() {
      var v = current();
      if (!v) return;
      if (vidInput) vidInput.value = v.id;
      if (priceBox) priceBox.innerHTML = priceHTML(v);
      if (image && v.image) { image.setAttribute('src', v.image); image.removeAttribute('srcset'); }
      var soldOut = !v.available;
      if (addBtn) {
        addBtn.disabled = soldOut;
        addBtn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      }
      if (addBtnLabel) addBtnLabel.textContent = soldOut ? soldLabel : addLabel;
    }

    root.querySelectorAll('[data-qv-opt]').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-qv-pill]');
        if (!pill) return;
        opt.querySelectorAll('[data-qv-pill]').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');
        apply();
      });
    });

    function add() {
      var v = current();
      if (!v || !v.available) return;
      if (errorBox) errorBox.textContent = '';
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (d) {
          var items = d.items || (d.id ? [d] : []);
          document.dispatchEvent(new CustomEvent('sniggles:cart:added', { detail: { items: items } }));
          if (window.SnigglesCart && typeof window.SnigglesCart.open === 'function') {
            window.SnigglesCart.open();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          if (errorBox) errorBox.textContent = (err && err.description) ? err.description : errLabel;
        })
        .finally(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); });
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    apply();
  }

  function openQV(url) {
    buildShell();
    lastFocus = document.activeElement;
    body.innerHTML = '<div class="sn-qv-loading" role="status">Loading&hellip;</div>';
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('sn-qv-lock');
    isOpen = true;
    var closeBtn = overlay.querySelector('.sn-qv-close');
    if (closeBtn) closeBtn.focus();

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=sniggles-quick-view';
    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.text(); })
      .then(function (html) {
        if (!isOpen) return;
        body.innerHTML = html;
        wireBuybox(body.querySelector('[data-sn-qv-buybox]'));
        var f = body.querySelector('a[href], button:not([disabled]), [tabindex]');
        if (f) f.focus();
      })
      .catch(function () {
        if (!isOpen) return;
        body.innerHTML = '<div class="sn-qv-error">Sorry &mdash; we could not load the quick view. ' +
          '<a class="sn-link" href="' + url + '">Open the product page</a>.</div>';
      });
  }

  function closeQV() {
    if (!overlay || !isOpen) return;
    overlay.setAttribute('hidden', '');
    body.innerHTML = '';
    document.documentElement.classList.remove('sn-qv-lock');
    isOpen = false;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // ------------------------------------------------------------- Delegation
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sn-swatch]');
    if (sw) { e.preventDefault(); onSwatchClick(sw); return; }

    var qv = e.target.closest('[data-sn-quickview]');
    if (qv) {
      e.preventDefault();
      var url = qv.getAttribute('data-product-url');
      if (url) openQV(url);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { closeQV(); return; }
    if (e.key === 'Tab' && dialog) {
      var f = dialog.querySelectorAll('a[href], button:not([disabled]), select, input, textarea, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Once an add-to-bag opens the cart drawer, close the quick view behind it.
  document.addEventListener('sniggles:cart:added', function () { if (isOpen) closeQV(); });
})();
